// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccountApplicationFilterController from "./account_application_filter_controller"
application.register("account-application-filter", AccountApplicationFilterController)

import AccountApplicationFormController from "./account_application_form_controller"
application.register("account-application-form", AccountApplicationFormController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import CollapsibleController from "./collapsible_controller"
application.register("collapsible", CollapsibleController)

import ContactFormController from "./contact_form_controller"
application.register("contact-form", ContactFormController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import LocalePreviewController from "./locale_preview_controller"
application.register("locale-preview", LocalePreviewController)

import MenuController from "./menu_controller"
application.register("menu", MenuController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import RemovableController from "./removable_controller"
application.register("removable", RemovableController)

import SirenAutocompleteController from "./siren_autocomplete_controller"
application.register("siren-autocomplete", SirenAutocompleteController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)
